// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f0726693","160":"30baec89","787":"dfe42647"}[chunkId] + ".chunk.js";
};